import { ListItem } from '@tableau/widgets';

import { Messages } from '../../codegen/Localize';
import { ISiteAdminProfile } from '../users/serverApi/requests/GetSiteAdminProfilesRequest';
import { ADMIN_PROFILE_NONE_VALUE } from './AdminProfileConstants';

/** Dropdown list max height to match other dialogs (e.g. schedule, auth) and keep popup opening downward. */
export const ADMIN_PROFILE_LIST_MAX_HEIGHT = '200px';

/** Width to match SiteRolePickerMenu (DefaultDropdownMenuWidth 370 minus spacing). Use same style for consistency. */
export const ADMIN_PROFILE_DROPDOWN_WIDTH = 362;

/** Sort by `name` for dropdown display (case-insensitive, locale-aware). */
export function sortAdminProfilesByDisplayName<T extends { name?: string | null }>(
  profiles: readonly T[],
): T[] {
  return [...profiles].sort((a, b) =>
    (a.name ?? '').localeCompare(b.name ?? '', undefined, { sensitivity: 'base' }),
  );
}

/** Build list items for the admin profile dropdown: None + all profiles (profiles sorted by name). */
export function getAdminProfileListItems(
  profiles: ISiteAdminProfile[],
  noneValue: string = ADMIN_PROFILE_NONE_VALUE
): ListItem[] {
  const items: ListItem[] = [{ value: noneValue, content: Messages.adminProfile_None() }];
  sortAdminProfilesByDisplayName(profiles || []).forEach((p: ISiteAdminProfile) => {
    items.push({ value: p.luid, content: p.name });
  });
  return items;
}
